import { PaintThicknessRange } from './PaintThicknessLegend.types';

/**
 * Definicja zakresów grubości lakieru zgodnie z designem Figma
 * Kolory dobrane na podstawie screenshotów z Figma
 */
export const paintThicknessRanges: PaintThicknessRange[] = [
  {
    min: 0,
    max: 100,
    backgroundColor: '#148B4D', // Zielony
    borderColor: '#148B4D',
    label: 'Optymalnie',
  },
  {
    min: 100,
    max: 200,
    backgroundColor: '#73C69B', // Jasny zielony
    borderColor: '#73C69B',
  },
  {
    min: 200,
    max: 400,
    backgroundColor: '#FFD91B', // Żółty
    borderColor: '#FFD91B',
  },
  {
    min: 400,
    max: 900,
    backgroundColor: '#FE6728', // Pomarańczowy
    borderColor: '#FE6728',
  },
  {
    min: 900,
    backgroundColor: '#EE2A2A', // Czerwony
    borderColor: '#EE2A2A',
    label: 'Ostrzegawczo',
  },
];

/**
 * Formatuje zakres do wyświetlenia (np. "0 - 100", "400 - 900")
 */
export const formatRange = (range: PaintThicknessRange): string => {
  if (range.max === undefined) {
    return `${range.min}+`;
  }
  return `${range.min} - ${range.max}`;
};
